module.exports = __webpack_public_path__ + "img/fyt_p14.66b854a2.png";